"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var core_1 = require("@dynamynd/core");

var modules_1 = require("@dynamynd/modules");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("../../../components");

var SectionResultsIntro = function SectionResultsIntro(_a) {
  var resultsHasData = _a.resultsHasData,
      activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      height = _a.height,
      messageText = _a.messageText,
      scrollToElementHandler = _a.scrollToElementHandler,
      name = _a.name,
      getModulesFailed = _a.getModulesFailed,
      refreshResults = _a.refreshResults,
      refreshExhausted = _a.refreshExhausted,
      content = _a.content;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);
  var showButton = !smallOrMedium;
  var subtitleLineHeight = responsive_1.isSmallOrMedium(activeBreakpoint) ? 25 : 30;

  var _b = content_parser_1.parseResultsIntroContent(content),
      titleContent = _b.titleContent,
      congratsContent = _b.congratsContent,
      beYouContent = _b.beYouContent,
      paragraphContent = _b.paragraphContent;

  var renderBrandName = function renderBrandName() {
    return react_1.default.createElement(react_1.default.Fragment, null, "Kolbe Y", react_1.default.createElement(content_parser_1.Trademark, null, "\u2122"), " Index.");
  };

  return react_1.default.createElement(modules_1.ViewSectionContainer, null, react_1.default.createElement(exports.SectionContentRowCentered, null, react_1.default.createElement(SectionContentContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_1.OwlImage, {
    source: {
      uri: components_lib_1.appConfig.images.surveyResultsIntroSectionOwl
    }
  }), react_1.default.createElement(BubbleImage, {
    source: {
      uri: components_lib_1.appConfig.images.surveyResultsSpeechBubble
    },
    activeBreakpoint: activeBreakpoint,
    screenWidth: width,
    resizeMode: "contain"
  }, react_1.default.createElement(ResultsIntroTextWrapper, {
    activeBreakpoint: activeBreakpoint,
    screenWidth: width
  }, resultsHasData ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_lib_1.Heading, {
    size: components_lib_1.HeadingSizeEnum.big
  }, name, ",", '\n', titleContent, renderBrandName(), react_1.default.createElement(modules_1.PartyIcon, {
    resizeMode: "stretch",
    source: {
      uri: components_lib_1.appConfig.icons.party
    }
  })), react_1.default.createElement(SubtitleContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big,
    customLineHeight: subtitleLineHeight
  }, paragraphContent)), react_1.default.createElement(SubtitleContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big,
    customLineHeight: subtitleLineHeight
  }, congratsContent)), react_1.default.createElement(SubtitleContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big,
    customLineHeight: subtitleLineHeight
  }, beYouContent)), showButton && react_1.default.createElement(ResultsIntroButtonWrapper, {
    activeBreakpoint: activeBreakpoint,
    justify: "start"
  }, react_1.default.createElement(components_lib_1.Button, {
    text: "See Your Results",
    uppercase: true,
    type: components_lib_1.ButtonTypeEnum.primary,
    icon: {
      name: 'arrow-down',
      position: components_lib_1.ButtonIconPositionEnum.right,
      size: components_lib_1.IconSizeEnum.small,
      color: 'white'
    },
    onPress: function onPress() {
      return scrollToElementHandler(modules_1.ModuleSectionViewsEnum.intro);
    }
  }))) : react_1.default.createElement(LoadingMessageContainer, null, !getModulesFailed ? react_1.default.createElement(components_lib_1.LoadingIndicator, {
    size: "small"
  }) : null, react_1.default.createElement(SubtitleContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big,
    customLineHeight: subtitleLineHeight
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: messageText
  }))), getModulesFailed && !refreshExhausted ? react_1.default.createElement(ResultsIntroButtonWrapper, {
    activeBreakpoint: activeBreakpoint,
    justify: "start"
  }, react_1.default.createElement(components_lib_1.Button, {
    text: "Refresh Results",
    uppercase: true,
    type: components_lib_1.ButtonTypeEnum.primary,
    onPress: refreshResults
  })) : null)))), react_1.default.createElement(ShapeContainer, {
    activeBreakpoint: activeBreakpoint,
    screenHeight: height
  }, react_1.default.createElement(ShapeImage, {
    source: {
      uri: components_lib_1.appConfig.images.surveyResultsIntroSectionShape
    },
    screenHeight: height
  }))));
};

var xSmallBreakpoint = 600;
exports.SectionContentRowCentered = styled_components_1.default(components_lib_1.RowCenteredResponsive)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    align-items: flex-start;\n    height: 100%;\n"], ["\n    position: relative;\n    align-items: flex-start;\n    height: 100%;\n"])));
var ShapeContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenHeight = _a.screenHeight,
      rest = __rest(_a, ["activeBreakpoint", "screenHeight"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    position: absolute;\n    top: -200px;\n    left: -32px;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    position: absolute;\n    top: -200px;\n    left: -32px;\n"])));
var ShapeImage = styled_components_1.default(function (_a) {
  var screenHeight = _a.screenHeight,
      rest = __rest(_a, ["screenHeight"]);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 1120px;\n    height: 700px;\n"], ["\n    width: 1120px;\n    height: 700px;\n"])));
var SectionContentContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(components_lib_1.Row, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    z-index: 2;\n    margin: 0 auto;\n    justify-content: flex-end;\n    ", "\n"], ["\n    z-index: 2;\n    margin: 0 auto;\n    justify-content: flex-end;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            bottom: " + (small ? 0 : 10) + "%;\n            flex-direction: " + (small ? 'column-reverse' : 'row') + ";\n            " + (small ? "left: -" + core_1.GutterSizeEnum.small + "px" : '') + ";\n            align-items: " + (small ? 'flex-start' : 'flex-end') + ";\n        ";
});
var BubbleImage = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth,
      rest = __rest(_a, ["activeBreakpoint", "screenWidth"]);

  return react_1.default.createElement(react_native_1.ImageBackground, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    position: relative;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    position: relative;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);
  var xSmall = screenWidth < xSmallBreakpoint;
  var scale = xSmall ? 'transform: scale(1.5)' : '';
  return "\n            " + (smallOrMedium ? "left: -13%" : '') + ";\n            " + scale + ";\n            " + setBubbleImageDimensions(activeBreakpoint, screenWidth) + "\n        ";
});

function setBubbleImageDimensions(activeBreakpoint, screenWidth) {
  var aspect = 1.126;
  var delimiter = calculateDelimiter(activeBreakpoint, screenWidth);
  var width = screenWidth / delimiter;
  var height = width / aspect;
  return "\n        width: " + width + "px;\n        height: " + height + "px;\n    ";
}

function calculateDelimiter(activeBreakpoint, screenWidth) {
  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    if (screenWidth < 1220) return 1.4;
    if (screenWidth < 1380) return 1.5;
    return 1.7;
  }

  if (responsive_1.isLarge(activeBreakpoint)) {
    if (screenWidth < 1100) return 1.2;
    return 1.3;
  }

  if (responsive_1.isMedium(activeBreakpoint)) {
    if (screenWidth < 900) return 1;
    return 1.1;
  } // small


  return 0.8;
}

var ResultsIntroTextWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth,
      rest = __rest(_a, ["activeBreakpoint", "screenWidth"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    align-items: flex-start;\n    justify-content: center;\n    position: absolute;\n    left: 50%;\n    ", "\n"], ["\n    align-items: flex-start;\n    justify-content: center;\n    position: absolute;\n    left: 50%;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);
  var xSmall = screenWidth < xSmallBreakpoint;
  return "\n            max-width: " + (smallOrMedium ? xSmall ? 340 : 360 : 460) + "px;\n            margin-left: -" + (smallOrMedium ? xSmall ? 210 : 280 : 200) + "px;\n            bottom: " + (smallOrMedium ? xSmall ? 10 : 20 : 20) + "%;\n        ";
});
var SubtitleContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", "px;\n"], ["\n    margin-top: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? 8 : responsive_1.isMedium(activeBreakpoint) ? 4 : 16;
});
var ResultsIntroButtonWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: 32px;\n    display: flex;\n    justify-content: ", ";\n"], ["\n    margin-top: 32px;\n    display: flex;\n    justify-content: ", ";\n"])), function (_a) {
  var justify = _a.justify;
  return justify || 'center';
});
var LoadingMessageContainer = styled_components_1.default(react_native_1.View)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: 140px;\n"], ["\n    margin-bottom: 140px;\n"])));
exports.default = responsive_1.withResponsiveMeta(SectionResultsIntro);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;